import { Button } from "../../ui/button";
interface FilterOption {
  value: string;
  label: string;
}
interface OrderFiltersProps {
  options: FilterOption[];
  selectedFilter: string;
  onFilterChange: (filter: string) => void;
}
export const OrderFilters = ({ options, selectedFilter, onFilterChange }: OrderFiltersProps) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {options.map((option) => (
        <Button
          key={option.value}
          variant={selectedFilter === option.value ? "default" : "outline"}
          size="sm"
          className={`whitespace-nowrap h-10 px-4 ${
            selectedFilter === option.value
              ? ''
              : 'border-gray-300 text-gray-700 hover:border-gray-400 hover:bg-gray-50'
          }`}
          onClick={() => onFilterChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};